export default "__VITE_ASSET__5312e287__"